const organizationUserReducer = (
    state = {
      data: undefined,
    },
    action: {
      type: "FETCH_ORGANIZATION_RESOURCE";
      payload: any;
    }
  ) => {
    switch (action.type) {
      case "FETCH_ORGANIZATION_RESOURCE":
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default organizationUserReducer;
  